import React from "react"

function FormLabel({ text, className }) {
  return (
    <div className={"textforinput marginTop10px " + className}>
      <p>{text}</p>
    </div>
  )
}
export default FormLabel
